exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-link {\r\n  cursor: pointer;\r\n}\r\n.disabledDIV {\r\n    pointer-events: none;\r\n    opacity: .4; \r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/productfilter/productfilter.component.css
// module id = ../../../../../src/app/container/products-and-filter/productfilter/productfilter.component.css
// module chunks = main